export class DialogAddCommentData {
	public constructor(public text: string = null) {}
}
